import React from 'react'
import { useMutation } from '@apollo/react-hooks'

import { DataList, EmptyDataMessage } from '../../components/Data'
import { PageHeader, Content } from '../../components/Layout'
import { CreateFab, Loader, useConfirm } from '../../components/UI'
import { CORPORATION_TYPES_ROWS_PER_PAGE, useCorporationTypes } from '../../graphql/hooks/businesses'
import { ICorporationType } from '../../graphql/types/businesses'
import { UpsertCorporateTypeModal } from './corporateTypes/UpsertCorporateTypeModal'
import { DELETE_CORPORATION_TYPE, GET_CORPORATION_TYPES_BY_ADMIN } from '../../graphql/queries/businesses'
import { useQueryParams } from '../../utils'
import { Box, Divider } from '@material-ui/core'
import Pagination from '../../components/Data/pagination/Pagination'

const CorporateTypes: React.FC = () => {
  const confirm = useConfirm()
  const [, setQuery] = useQueryParams()
  const [modalVisible, setModalVisible] = React.useState<boolean>(false)
  const [editingType, setEditingType] = React.useState<ICorporationType | null>(null)
  const { corporationTypes, total, loading, page, limit } = useCorporationTypes()

  const handleCreate = () => {
    setModalVisible(!modalVisible)
  }

  const handleEdit = (type: ICorporationType) => {
    setEditingType(type)
    setModalVisible(true)
  }

  const handleClose = () => {
    setEditingType(null)
    setModalVisible(false)
  }

  const [deleteCorporationType] = useMutation(DELETE_CORPORATION_TYPE, {
    refetchQueries: [
      {
        query: GET_CORPORATION_TYPES_BY_ADMIN,
        variables: {
          pagination: { offset: 0, limit: CORPORATION_TYPES_ROWS_PER_PAGE[0] },
        },
      },
    ],
  })

  const handleDelete = async (item: ICorporationType) => {
    try {
      await confirm({ message: `Вы уверены, что хотите удалить` })
      await deleteCorporationType({ variables: { id: item.id } })
    } catch {
      return
    }
  }

  const handleChangePerPage = (perPage: number) => {
    if (perPage !== limit) {
      setQuery({ page: 1, limit: perPage })
    }
  }

  const handleChangePage = (p: number) => {
    setQuery({ page: p + 1 })
  }

  return (
    <div>
      <PageHeader title='Типы корпорации' />
      {loading && <Loader />}
      {corporationTypes.length === 0 && !loading ? (
        <EmptyDataMessage />
      ) : (
        <Content noGutter>
          <DataList data={corporationTypes} title={'name'} onEdit={handleEdit} onDelete={handleDelete} />
          <Divider />
          <Box mt={3}>
            <Pagination
              rowsPerPage={CORPORATION_TYPES_ROWS_PER_PAGE[0]}
              rowsPerPageOptions={CORPORATION_TYPES_ROWS_PER_PAGE}
              onChangeRowsPerPage={handleChangePerPage}
              onChangePage={handleChangePage}
              page={page - 1}
              count={total}
            />
          </Box>
        </Content>
      )}
      <CreateFab onClick={handleCreate} />
      {modalVisible && (
        <UpsertCorporateTypeModal open={modalVisible} corporationType={editingType} onCancel={handleClose} />
      )}
    </div>
  )
}

export default CorporateTypes
